// Row drag-and-drop for the Gantt's left list (owner, 2026-10-10): drag a
// row onto another and drop on its upper half to put it ABOVE, lower half
// BELOW - the plan table's "Move above / below row", with its subtree.
// Plain HTML5 drag events; the state lives with the caller:
//   drag  = { get(), set(id) }        the dragged row's id (a ref)
//   drop  = { get(), set(value) }     { key, where } for the indicator
export const whereIn = (rect, clientY) => (clientY - rect.top < rect.height / 2 ? "above" : "below");

export function rowDragHandlers(id, { drag, drop, onMoveRow }) {
  return {
    draggable: true,
    onDragStart: (e) => {
      drag.set(id);
      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = "move";
        try { e.dataTransfer.setData("text/plain", id); } catch (err) { /* old browsers */ }
      }
    },
    onDragEnd: () => { drag.set(null); drop.set(null); },
    onDragOver: (e) => {
      const from = drag.get();
      if (!from || from === id) return;
      e.preventDefault();
      const where = whereIn(e.currentTarget.getBoundingClientRect(), e.clientY);
      const cur = drop.get();
      if (!(cur && cur.key === id && cur.where === where)) drop.set({ key: id, where });
    },
    onDrop: (e) => {
      e.preventDefault();
      const from = drag.get();
      const cur = drop.get();
      const where = cur && cur.key === id ? cur.where : whereIn(e.currentTarget.getBoundingClientRect(), e.clientY);
      drag.set(null);
      drop.set(null);
      if (from && from !== id) onMoveRow(from, id, where);
    },
  };
}
